import Icon from 'veui/components/Icon'
import { IconThumbDownSolid } from 'dls-icons-vue'

Icon.register('thumb-down-solid', IconThumbDownSolid)
